angular.module('dealerware.web.filters').filter('filterDealerwareRoles', function() {

    const DEALERWARE_ROLES = {
        accounting: 'Allows user to manually charge or refund customer credit cards in Dealerware Web',
        admin: 'Allows user access to the Settings menu in Dealerware Web',
        car_manager: 'For Dealerships with sub-locations, allows user to move vehicles between sub-locations',
        customer_confirmer: 'Allows user to manually confirm employees',
        dnr_manager: 'Allows user to flag customers as "Do not Rent", preventing loaner contracts from being created',
        user_manager: 'Allows user to access the Employees section in the main menu',
        user_role_manager: 'Allows user to create employees and edit employee account settings',
        operations_manager: 'Allows user to reset employee passwords',
        service_advisor: 'Allows user to be assigned to contracts as a Service Advisor',
        dispose_vehicles: 'Allows user to move a vehicle into a disposed status',
        view_reports: 'Allows user to access and view reports',
        view_vehicle_position_during_contracts: 'Allows admin user to view vehicle position during contracts. Connected Car Devices required.'
    };

    return function (items) {
        var filteredItems = [];

        if (items && angular.isArray(items)) {
            items.forEach(function(item) {
                if (item.data.name in DEALERWARE_ROLES) {
                    item.data.description = DEALERWARE_ROLES[item.data.name];
                    item.data.requires_role = item.data.name === 'view_vehicle_position_during_contracts' ? 'admin' : undefined;
                    filteredItems.push(item);
                }
            });
        }

        return filteredItems;
    };
});
